// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.65c2c089a',
  revision: '65c2c089a',
  branch: 'develop',
  date: 'Thu, 13 Aug 2026 18:23:57 GMT'
};